import React, { FC } from 'react'
import {
  CardInner,
  CardOutlined,
  CardGreyHeadline,
  DefaultStocksDetailCard,
  CardOutlinedInner,
  HoursToDeadlineDetailCard,
} from 'components/Card'
import { ScheduleType } from 'types/schedule'
import { Spacer } from 'components/Utility'

type Props = {
  schedules: ScheduleType[]
}

const ScheduleDetailCard: FC<Props> = (props) => {
  const { schedules } = props

  return (
    <CardOutlined>
      <CardGreyHeadline headline={'注文締め切り'} isTop={true} />
      <Spacer size={8} />
      <CardOutlinedInner>
        {schedules.map((schedule) => (
          <React.Fragment key={schedule.schedule_ref?.id}>
            <HoursToDeadlineDetailCard schedule={schedule} />
            <Spacer size={8} />
          </React.Fragment>
        ))}
      </CardOutlinedInner>
      <CardGreyHeadline headline={'受渡解禁時刻と1日の販売上限数'} />
      <Spacer size={8} />
      <CardInner>
        {schedules.map((schedule) => (
          <React.Fragment key={schedule.schedule_ref?.id}>
            <DefaultStocksDetailCard schedule={schedule} type={schedule.type as 'preorder' | 'daily'} />
            <Spacer size={8} />
          </React.Fragment>
        ))}
      </CardInner>
    </CardOutlined>
  )
}

export default ScheduleDetailCard
